import type { FileType } from "./types";

export const WEB_PAGES_FLAG = "ampWebPagesEnabled";
export const PAGES_FLAG = "ampPagesEnabled";

export function fileTypeAccess({
  amp,
  ads,
  lcm,
  webPages,
  pages,
}: {
  amp: boolean;
  ads: boolean;
  lcm: boolean;
  webPages: boolean;
  pages: boolean;
}): Record<FileType, boolean> {
  return {
    ad: amp && ads,
    email: amp && lcm,
    sms: amp && lcm,
    push: amp && lcm,
    html: amp && webPages,
    page: amp && pages,
    doc: amp,
    upload: amp,
    slides: amp,
    canvas: amp,
  };
}
